module.exports = __webpack_public_path__ + "img/rentable.3de9839c.png";